import * as classes from './TextImage.module.css'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

const TextImage = ({ text, image, ctaButton }) => {
  if (!text || !image) return (<></>)

  return (
    <section className={`${classes.bgLight}`}>
      <div className={`container ${classes.textImage}`}>
        <div className={classes.left}>
          {documentToReactComponents(text)}
          {ctaButton && <div className={classes.cta}>
            <a href={ctaButton.fields?.url} target={ctaButton.fields?.target} className={'button'}>
              {ctaButton.fields?.title}
            </a>
          </div>}
        </div>
        <div className={classes.right}>
          <link rel="preload" fetchPriority="high" as="image" href={`${image.file?.url}?fm=webp&w=620`} type="image/webp" />
          <img
            src={`${image.file?.url}?fm=webp&w=620`}
            srcSet={`${image.file?.url}?fm=webp&h=300 311w, ${image.file?.url}?fm=webp&w=620 312w`}
            width={image.file?.details?.image?.width}
            height={image.file?.details?.image?.height}
            alt={image.title} />
        </div>
      </div>
    </section>
  )
}

export default TextImage
